export default __webpack_public_path__ + "static/media/Nutella Donut -proportioned_170.ed2d752d.jpg";